import Modal from '../../../components/Modal'
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'

export type Props = {
  open: boolean
  onClose: () => void
}
const createData = (
  paymentMethod: string,
  paymentPerFee: string,
  feeAsPercentage: string,
  feeCap: string
) => {
  return { paymentMethod, paymentPerFee, feeAsPercentage, feeCap }
}

const rows = [
  createData('ACH', 'USD 0.86', '0%', ''),
  createData('eCheck (International)', 'USD 5.75', '0%', ''),
  createData('PayPal (United States)', 'USD 0.86 + 3.5%', '2%', 'USD 1.75'),
  createData('PayPal (International)*', 'USD 0.86 + 3.5%', '2%', 'USD 20.75'),
  createData('Wire Transfer (Local)', 'USD 17.25', '0%', 'USD 0.00'),
  createData(
    'Wire Transfer (International in USD)',
    'USD 23.00',
    '0%',
    'USD 0.00'
  ),
  createData('Check', 'USD 3.45', '0%', '')
]

const styles = {
  container: {
    width: 900,
    padding: '15px'
  },
  title: {
    display: 'flex',
    gap: '2px',
    fontWeight: 'bold',
    padding: '15px',
    alignItems: 'center'
  },
  footer: {
    padding: '15px'
  },
  table: {
    minWidth: 650,
    padding: 'normal'
  }
}

export const FeeSchedule = ({ open, onClose }: Props) => {
  return (
    <Modal open={open} onClose={onClose} styles={styles}>
      <Box sx={styles.title}>
        <CalendarMonthIcon />
        <Typography variant="h6">Fee Schedule</Typography>
      </Box>
      <TableContainer component={Paper} data-testid="fee-schedule-table">
        <Table sx={styles.table} aria-label="Fee schedule table">
          <TableHead>
            <TableRow>
              <TableCell align="center">Payment Method</TableCell>
              <TableCell align="center">Per Payment Fee</TableCell>
              <TableCell align="center">Fee as % of payment</TableCell>
              <TableCell align="center">Fee Cap</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.paymentMethod}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component="th" scope="row" align="center">
                  {row.paymentMethod}
                </TableCell>
                <TableCell align="center">{row.paymentPerFee}</TableCell>
                <TableCell align="center">{row.feeAsPercentage}</TableCell>
                <TableCell align="center">{row.feeCap}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Typography sx={styles.footer}>
        *International PayPal payments are sent in USD 9,500 increments and will
        result in multiple fees for each transfer if amounts over USD 9,500 are
        processed
      </Typography>
      <Typography sx={{ ...styles.footer, fontWeight: 'bold' }}>
        Recommended payment methods are ACH for partners in the US and eChecks
        for international partners.
      </Typography>
    </Modal>
  )
}
